/* eslint-disable string-to-lingui/missing-lingui-transformation */
import { Box } from '@mui/material'
import { FunctionComponent } from 'react'

export const SettingsPage: FunctionComponent = () => {
    return <Box sx={{ height: '86vh', overflow: 'hidden' }}></Box>
}
